import {Decimal} from 'decimal.js';

export default function(val)
{
    return `€ ${new Decimal(val).toFixed(4).replace('.', ',')}`;
}